"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchNoticeList = exports.getBrowserLang = void 0;

var config_1 = require("../constants/config");

var load_script_1 = __importDefault(require("load-script"));

var getBrowserLang = function getBrowserLang() {
  var lang = "ko";
  var aLang = {
    "ko-KR": "ko_KR",
    "ko": "ko_KR",
    "en": "en_US",
    "en-US": "en_US",
    "ja": "ja_JP",
    "ja-JP": "ja_JP",
    "zh-CN": "zh_CN",
    "zh-cn": "zh_CN",
    "zh-TW": "zh_TW",
    "zh-tw": "zh_TW",
    "th": "th_TH",
    "th-TH": "th_TH" // "vi" : "vi_VN",
    // "vi-VN" : "vi_VN"

  };

  if (!window.navigator.language) {
    lang = "ko";
  }

  lang = window.navigator.language;
  lang = lang.toLocaleLowerCase();

  if (lang === "zh-tw" || lang === "zh-cn") {
    return aLang[lang];
  }

  lang = lang.substring(0, 2); //미지원 언어일 시, 영어

  if (!aLang[lang]) {
    return "en_US";
  }

  return aLang[lang];
};

exports.getBrowserLang = getBrowserLang;

function fetchNoticeList() {
  var noticeList = Array();
  var lang = (0, exports.getBrowserLang)();
  var url = "".concat(config_1.RES_DOMAIN, "/data/afreeca_notice_portlet_").concat(lang, ".js");
  (0, load_script_1.default)("".concat(url), {
    charset: lang === "ko_KR" ? "euc-kr" : "utf-8"
  }, function () {
    if (lang === "ko_KR" && typeof window.afreeca_notice_item_sort != "undefined" && window.afreeca_notice_item_sort.length > 0) {
      window.afreeca_notice_item_sort.forEach(function (element) {
        noticeList.push({
          'i_link_url': window.afreeca_notice_item_link_url[element],
          'i_title': window.afreeca_notice_item_title[element],
          'i_reg_date': window.afreeca_notice_item_reg_date[element]
        });
      });
    } else if (lang !== "ko_KR" && typeof window.szNoticeInfo != "undefined" && window.szNoticeInfo.length > 0) {
      window.szNoticeInfo.forEach(function (element) {
        noticeList.push({
          'i_link_url': config_1.G_HELP_DOMAIN + "/index.php?pt=notice_detail&no=" + element.no,
          'i_title': element.title,
          'i_reg_date': element.date
        });
      });
    }
  });
  return noticeList;
}

exports.fetchNoticeList = fetchNoticeList;